require('./slick-default.less');

jQuery(function() {
    module.exports.params = {
        infinite: true,
        adaptiveHeight: true,
        slidesToScroll: 1,
        speed: 400
    };

    module.exports.paramsCssAnim = {
        cssEase: 'ease',
        useTransform: true,
        speed: 600
    };
});



// WEBPACK FOOTER //
// ./blocks/slick-default/slick-default.js